import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import _ from "lodash";
// import "firebase/auth";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: window.location.hostname,
  storage: window.localStorage
})

let store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    artikels: [],
    basket: undefined,
    userInfo: {},
    currentUser: undefined,
    homeCarousel: [],
    counter: 0,
    config: {
      naamKleintje: "Kleintje"
    }
  },
  mutations: {
    addArtikels: (state, array) => (state.artikels = array),
    makeReservation: (state, { artikel, id, value, confirmed }) => {
      if (id)
        (artikel.id = id),
          (state.basket = {
            artikel,
            value,
            // doc,
            confirmed: confirmed ? confirmed : false
          });
    },
    setUserinfo: (state, val) => (state.userInfo = val),
    setCurrentUser: (state, val) => {
      state.currentUser = val;
    },
    setHomeCarousel: (state, val) => {
      state.homeCarousel = val;
    },
    increase: state => (state.counter += 1),
    setConfig: (state, val) => (state.config = val),
    initialiseStore(state) {
      if (localStorage.getItem("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("store")))
        );
      }
    }
  },
  actions: {
    makeReservation: ({ commit }, data) => {
      commit("makeReservation", data);
    },
    clearBasket: ({ state }) => {
      state.basket = undefined;
    },
    logout: ({ commit, state }) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          state.currentUser = {};
          router.push("/login");
          commit("setCurrentUser", undefined);
        });
    }
  }
});

store.subscribe((mutation, state) => {
  localStorage.setItem("store", JSON.stringify(state));
});

export default store;
